import { render, staticRenderFns } from "./flightInfo.vue?vue&type=template&id=4fde9a36&scoped=true&"
import script from "./flightInfo.vue?vue&type=script&lang=js&"
export * from "./flightInfo.vue?vue&type=script&lang=js&"
import style0 from "./flightInfo.vue?vue&type=style&index=0&id=4fde9a36&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fde9a36",
  null
  
)

export default component.exports